import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '幸运麻将'
          }
        }, {
          path: '/exchangeLog',
          name: 'exchangeLog',
          component: resolve => require(['@/view/exchangeLog'], resolve),
          meta: {
            title: '兑换记录'
          }
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '幸运麻将 - 兑换商城'
          }
        }, {
          path: '/addressList',
          name: 'AddressList',
          component: resolve => require(['@/view/AddressList'], resolve),
          meta: {
            title: '收货地址'
          }
        },{
          path: '/login',
          name: 'login',
          component: resolve => require(['@/view/Login'], resolve),
          meta: {
            title: '幸运麻将 - 登录'
          }
        },
        {
          path: '/logout',
          name: 'logout',
          component: resolve => require(['@/view/logout'], resolve),
          meta: {
            title: '幸运麻将 - 退出登录'
          }
        },
        {
          path: '/download',
          name: 'download',
          component: resolve => require(['@/view/Download'], resolve),
          meta: {
            title: '幸运麻将 - 下载'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js